// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"314":"1c22044452fcc4116b8e","628":"50b6d505d9b27162537f"}[chunkId] + ".css";
};